console.log('%cBuilt by Not selling liquid', 'color:#000; font-weight:bold;');

if (document.querySelectorAll('.variant-grid')) {
  function quickAddButton() {
    document.querySelectorAll('.variant-grid').forEach(function (sizeList) {
      if (sizeList.dataset.quickAddBound) return;
      sizeList.dataset.quickAddBound = '1';
      sizeList.addEventListener('click', function (e) {
        e.preventDefault();
        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-card');
        let error_grid = error_grid_outer.querySelector('.grid-error');
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status == 422) {
              error_grid.innerHTML = data.description;
              setTimeout(function (e) {
                error_grid.innerHTML = '';
              }, 2000);
            } else {
              if (document.location.href.indexOf('/cart') > -1) {
                window.location.href = "/cart";
              } else {
                if (typeof load_cart == 'function') {
                  load_cart().then(function () {
                    if (typeof openCartDrawer == 'function') openCartDrawer();
                  });
                } else {
                  window.location.href = "/cart";
                }
              }
              const url = '/cart.js';
              fetch(url)
                .then((resp) => resp.json())
                .then(function (data) {
                  var cart_count = data.item_count;
                  if (cart_count > 0) {
                    document.querySelector('.cart-count').innerHTML = cart_count;
                  } else {
                    document.querySelector('.cart-count').innerHTML = '';
                  }
                })
                .catch(function (error) {
                  console.log(error);
                })
            }
          })
          .catch((error) => {
            console.error(error);
          });
      });
    });
    //     document.querySelectorAll('.quick-add').forEach(function(quickAdd){
    //       quickAdd.onclick = function(){
    //         document.querySelectorAll('.snippet-product-grid').forEach(function(everyProduct){       
    //           everyProduct.classList.remove('active-quick');
    //         });
    //         let gridimgbox = quickAdd.closest('.snippet-product-grid');      
    //         gridimgbox.classList.add('active-quick');
    //       };
    //     });
  }
  quickAddButton();
}
class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && !this.input.value.trim().length) {
        event.preventDefault();
      }
    });
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if (input_length > 0) {
        document.querySelectorAll('.search-Button').forEach(function (SeachButtons) {
          SeachButtons.disabled = false;
        });
      } else {
        document.querySelectorAll('.search-Button').forEach(function (SeachButtons) {
          SeachButtons.disabled = true;
        });
      }
    }, 300).bind(this));
  }
  onFormSubmit(event) {
    if (!this.input.value.trim().length) {
      event.preventDefault();
    }
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product,collection,query&resources[limit]=10&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
        if (typeof quickAddButton == 'function') {
          quickAddButton();
        }
        if (document.getElementById('SearchValue')) {
          document.getElementById('SearchValue').value = searchTerm;
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }
  open() {
    document.querySelector('.snippet-search-bar').classList.add('active-search-results');
  }
  close() {
    document.querySelector('.snippet-search-bar').classList.remove('active-search-results');
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
function search_recommendation() {
  let slider = document.querySelector('.search_recommended_slider');
  if (!slider || slider.classList.contains('is-initialized')) return;
  let splide = new Splide(slider, {
    type: 'slide',
    autoWidth: true,
    pagination: false,
    arrows: true,
    perMove: 3,
    breakpoints: {
      991: {
        perMove: 2,
      },
    },
  });
  let bar = document.querySelector('.search_recommended_slider .splide-progress-bar');
  splide.on('mounted move', function () {
    let end = splide.Components.Controller.getEnd() + 1;
    let rate = Math.min((splide.index + 1) / end, 1);
    bar.style.width = String(100 * rate) + '%';
  });
  splide.mount();

}
document.querySelectorAll('.mobile-search').forEach(function (searchButton) {
  searchButton.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector('body').classList.add('open-search');
    document.querySelector('body').classList.remove('open-drawer', 'open-menu', 'open-sort', 'open-filter');
    document.querySelector(".snippet-search-bar #Search").focus({ preventScroll: true });
    search_recommendation();
  });
});
document.querySelectorAll('.search-bar-close').forEach(function (searchClose) {
  searchClose.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector('body').classList.remove('open-search');
  });
});
function initProductSliders() {
  document.querySelectorAll('.snippet-product-card').forEach(function (card) {
    let slider = card.querySelector('.product-images .splide');
    if (slider && !slider.classList.contains('splide-initialized')) {
      new Splide(slider, {
        type: 'slide',
        perPage: 1,
        pagination: false,
        arrows: false,
        wheel: true,
      }).mount();
    }
  });
}
document.addEventListener('DOMContentLoaded', function () {
  initProductSliders();
});
document.addEventListener('keydown', function (evt) {
  var isEscape = evt.key === "Escape" || evt.key === "Esc" || evt.keyCode === 27;
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter', 'open-sort', 'open-drawer', 'open-menu', 'open-search', 'open-currency');
  }
});
var counttime = 0;
function cartNotification(cartId) {
  fetch(window.Shopify.routes.root + "?section_id=cart-notification")
    .then((response) => response.text())
    .then((responseText) => {
      const cnID = "cart-notification";
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const destination = document.querySelector(".cart-noti-popup");
      const source = html.getElementById(cnID);
      if (source && destination) destination.innerHTML = source.innerHTML;
      let lastItem = document.querySelector(".cart-noti-items .cart-noti-" + cartId).innerHTML;
      if (lastItem) document.querySelector(".cart-noti-items").innerHTML = lastItem;
      counttime = 0;
      const myInterval = setInterval(timer, 1000);
      document.body.classList.add("open-notification");
      function timer() {
        counttime++;
        if (counttime > 50) {
          setTimeout(() => {
            document.body.classList.remove("open-notification");
            document.querySelector(".cart-noti-popup").innerHTML = "";
          }, 1000);
          myStop();
        }
      }
      function myStop() {
        clearInterval(myInterval);
      }
      document.body.addEventListener("click", function (e) {
        var popup = document.querySelector(".cart-noti-popup");
        if (!popup.contains(e.target)) {
          document.body.classList.remove("open-notification");
          popup.innerHTML = "";
        }
      });
      if (document.querySelector('.cart-noti-close')) document.querySelector('.cart-noti-close').addEventListener('click', function (e) {
        e.preventDefault();
        document.body.classList.remove("open-notification");
        document.querySelector(".cart-noti-popup").innerHTML = "";
      });
      if (document.querySelector('.cart-noti-view-cart button')) document.querySelector('.cart-noti-view-cart button').addEventListener('click', function (e) {
        e.preventDefault();
        document.body.classList.remove("open-notification");
        document.querySelector(".cart-noti-popup").innerHTML = "";
        document.querySelector('body').classList.add('open-drawer');
      });
    });
}
function updateRecentlyViewedCount() {
  let recent = [];
  try {
    recent = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
  } catch (e) { }
  document.querySelectorAll('.recently-viewed-count').forEach(function (el) {
    el.textContent = recent.length;
    let parentLi = el.closest('li');
    if (parentLi) {
      parentLi.style.display = recent.length > 0 ? '' : 'none';
    }
  });
}

document.addEventListener('DOMContentLoaded', updateRecentlyViewedCount);
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    updateRecentlyViewedCount();
  }
});

function selectKlaviyoLanguageInputs() {
  const isFrench = window.location.hostname === 'fr.arte-antwerp.com';
  const targetLabel = isFrench ? 'French' : 'English';

  document.querySelectorAll('.klaviyo-form').forEach(function (container) {
    const input = container.querySelector('input[aria-label="' + targetLabel + '"]');
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
    }
  });
}

(function () {
  selectKlaviyoLanguageInputs();

  const observer = new MutationObserver(function (mutations) {
    const hasNewLanguageInput = mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).some(function (node) {
        if (node.nodeType !== 1) return false;
        return (node.getAttribute && (node.getAttribute('aria-label') === 'English' || node.getAttribute('aria-label') === 'French')) ||
               (node.querySelector && node.querySelector('input[aria-label="English"], input[aria-label="French"]'));
      });
    });
    if (hasNewLanguageInput) {
      selectKlaviyoLanguageInputs();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

if (navigator.userAgent.indexOf('iPhone') > -1) {
  document.querySelector("[name=viewport]").setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1");
}
if(document.querySelectorAll('video')) document.querySelectorAll('video').forEach(video => {
  video.muted = true;
  video.play().catch(() => {});
});
document.addEventListener("DOMContentLoaded", function() {
  document.body.addEventListener('click', function(e) {
    // Variant-specific sold-out button (size shown on card)
    const soldOutBtn = e.target.closest('.grid-variant-unavailable');
    if (soldOutBtn) {
      e.preventDefault();
      document.querySelectorAll('.grid-error').forEach(el => {
        el.style.display = 'none';
      });
      localStorage.setItem("KlaviyoOpen", "true");
      const targetUrl = soldOutBtn.getAttribute("data-url") || (soldOutBtn.querySelector("a") ? soldOutBtn.querySelector("a").getAttribute("href") : null);
      if (targetUrl) {
        window.location.href = targetUrl;
      }
      return;
    }

    // Whole-product sold-out link (no size selector shown on card)
    const soldOutLink = e.target.closest('.grid-soldout-notified');
    if (soldOutLink) {
      e.preventDefault();
      localStorage.setItem("KlaviyoOpen", "true");
      window.location.href = soldOutLink.getAttribute("href");
    }
  });
});

document.addEventListener("DOMContentLoaded", function() {
  if (localStorage.getItem("KlaviyoOpen") === "true") {
    localStorage.removeItem("KlaviyoOpen");

    // Wait 1500ms so Klaviyo's async script fully loads + product-form.js initializes
    setTimeout(function() {

      // Step 1: Read variant ID from URL and click its swatch label
      var urlParams = new URLSearchParams(window.location.search);
      var variantId = urlParams.get('variant');

      if (variantId) {
        var variantRadio = document.querySelector(
          '.swatch-list input[name="id"][value="' + variantId + '"], ' +
          '.shoes-dropdown__grid input[name="id"][value="' + variantId + '"]'
        );
        if (variantRadio) {
          var swatch = variantRadio.closest('label');
          if (swatch) {
            swatch.click();
          } else {
            variantRadio.checked = true;
            variantRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }

      // Step 2: Poll until ATC button has .sold-out class, then click it
      // (klaviyoReady check removed — 1500ms head-start is enough)
      var attempts = 0;
      var maxAttempts = 25; // 25 x 300ms = 7.5 seconds max

      var tryClickAtc = setInterval(function() {
        attempts++;
        if (attempts > maxAttempts) {
          clearInterval(tryClickAtc);
          return;
        }

        // Target only the main product form button (not sticky drawer)
        var atcBtn = document.querySelector('.product-right-inner .add-to-cart-btn') ||
                     document.querySelector('.product-form-snippet .add-to-cart-btn');

        if (atcBtn && atcBtn.classList.contains('sold-out')) {
          clearInterval(tryClickAtc);

          // Change type "submit" → "button" so form submit doesn't fire
          // (product-form.js uses stopImmediatePropagation on submit which blocks Klaviyo)
          var originalType = atcBtn.getAttribute('type') || 'submit';
          atcBtn.setAttribute('type', 'button');
          atcBtn.click();

          setTimeout(function() {
            atcBtn.setAttribute('type', originalType);
          }, 0);
        }
      }, 300);

    }, 1500);
  }
});